import { IMG_HOSTING, isMainPackage } from './domain';

// 上传地址 https://image-tools.mytestdrama.com/index.html

export const IMG_HOSTING_URLS = {
    WALLET_CARD_BG: `${IMG_HOSTING}1679940ee99ea515bf047d8501c67876.png`,
    MY_CARD_BG: `${IMG_HOSTING}e7a406620c12082a000bd63a66d6d815.png`,
    COINS_28: `${IMG_HOSTING}dcd6669101a8d9d0ac9a18c92809992c.png`,
    COINS_24: `${IMG_HOSTING}3c58ef011abdb2619c16cb611bdaad24.png`,
    COINS_20: `${IMG_HOSTING}4c55cd4da1cf90074deaf703d9cdcfcd.png`,
    BONUS_28: `${IMG_HOSTING}aaaf167eff7812473e739a7f55ebd8c9.png`,
    BONUS_24: `${IMG_HOSTING}b6ff56a4e6a2fd888a9bb49ff41af163.png`,
    BONUS_20: `${IMG_HOSTING}afa3d33fc27627a7b96eb05d2e42c558.png`,
    VIP_20: `${IMG_HOSTING}64ac5d9be230e8025c3acfee9974a66c.png`,
    BONUS_EXPIRED_22: `${IMG_HOSTING}f9ef73a76f800f218b32f9fa289891ff.png`,
    BONUS_LOCK: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    CANCEL_PAY_IMG_URL: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    PAYPAL_LOADING_LOGO: `${IMG_HOSTING}92046216db770fbf36e25e11c6c35a10.png`,
    PAYPAL_LOADING_SPINNER: `${IMG_HOSTING}ea75768d242ba3c6fe287a7372c42064.svg`,
    STRIPE_LOADING_CARD_LOGO: `${IMG_HOSTING}3870e3ad59d50f737a16fc5f8fbab1ce.png`,
    STRIPE_LOADING_CARD_SPINNER: `${IMG_HOSTING}5ac43be1b733540f1de9b0d51f2f6fce.svg`,
    STRIPE_LOADING_APPLE_LOGO: `${IMG_HOSTING}86d5d7c1fc92e1d152b1c2fac8943ea9.png`,
    STRIPE_LOADING_APPLE_SPINNER: `${IMG_HOSTING}7db695bff3aedf9c16ac8350dce88f75.svg`,
    STRIPE_LOADING_GOOGLE_LOGO: `${IMG_HOSTING}ac4c2320cf112eb17164318f67e5ebd6.png`,
    STRIPE_LOADING_GOOGLE_SPINNER: `${IMG_HOSTING}7abdda8097688f7305aba741e4cfaa17.svg`,
    PAYWALL_APPLE_PAY_ICON: `${IMG_HOSTING}c1646a212cb344f57582b64a12f4bdb2.svg`,
    PAYWALL_GOOGLE_PAY_ICON: `${IMG_HOSTING}4d21a34ea894b8a3b43baf42d6a8a6b2.svg`,
    PAYWALL_CARD_PAY_ICON: `${IMG_HOSTING}6fd2cf9baa8c359d52b50c61f2379fde.svg`,
    PAYWALL_APPLE_PAY_ICON_DARK: `${IMG_HOSTING}2bf44e03bd86bcb891718fd2466abe53.svg`,
    PAYWALL_CARD_PAY_ICON_DARK: `${IMG_HOSTING}1c6445ac67f245a6937c2ed13ff25a38.svg`,
    PAYWALL_PAYPAL_PAY_ICON_DARK: `${IMG_HOSTING}9fee0a65eeb1de1f936959c53619cb28.svg`,
    // 新付费墙：订阅轮播卡左上角 Popular 飘带 / 解锁宝石图
    PAYWALL_POPULAR_RIBBON: `${IMG_HOSTING}popular.png`,
    PAYWALL_UNLOCK_STONE: `${IMG_HOSTING}unlock_stone.png`,
    // 新付费墙：订阅轮播卡右侧背景图（浅色 / 深色主题）
    PAYWALL_SUBSCRIBE_CARD_BACK_LIGHT: `${IMG_HOSTING}light-paywall-back.png`,
    PAYWALL_SUBSCRIBE_CARD_BACK_DARK: `${IMG_HOSTING}dark-paywall-back.png`,
    // 主包 / 分包占位图差异化，见下方赋值
    EMPTY_PLACEHOLDER: '',

    // 网格 Best Value 火焰飘带，仅在 marketingLabel === 'best_value' 时渲染
    PAYWALL_BAST_VALUE_ICON: `${IMG_HOSTING}52046e0965d1c55f54663b1e2a721cf0.png`,
    // 整本轮播卡：书名图标 / 左上角 Save 飘带
    PAYWALL_FULLBOOK_BOOK_ICON: `${IMG_HOSTING}d706f8f61417691e532bebb15985a063.png`,
    PAYWALL_FULLBOOK_SAVE_ICON: `${IMG_HOSTING}19799a32c4b507d2ef930290946c316c.png`,
    // 一次性会员：3D 图标、天数前缀图
    PAYWALL_ONCE_VIP_ICON: `${IMG_HOSTING}9d7c1c2ed83ab7754186345bcb7e70ae.png`,
    PAYWALL_VIP_RIGHT_BG: `${IMG_HOSTING}973823d88f276b37a65f21cb3fc4a266.png`,

    // 付费墙折扣商品
    PAYWALL_OFFER_GOODS_CARD_BG: `${IMG_HOSTING}dac9b8aead92cf3c7927f520fc2f0ac7.png`,
    PAYWALL_OFFER_GOODS_CARD_OFFER_BG: `${IMG_HOSTING}93b3f48072aac5568576faf79aeb01e0.png`,

    // 充值挽留弹窗
    DIALOG_RECHARGE_MAIN_BG: `${IMG_HOSTING}5126bba3a80da3baa638dc95241c3662.png`,
    DIALOG_RECHARGE_MAIN_IMAGE: `${IMG_HOSTING}77595390bcd448adb575a020e9b82283.png`,
    DIALOG_RECHARGE_OFFER_BG: `${IMG_HOSTING}ea0b05b31a25291e4362f31190bcfe29.png`,
    DIALOG_RECHARGE_WIDGET_IMAGE: `${IMG_HOSTING}923e8072d1347a7c931ed4f8618fb8f5.png`,
    DIALOG_RECHARGE_TITLE: `${IMG_HOSTING}158144c335af9a7a62773f72a00daca0.png`,
    DIALOG_RECHARGE_BUTTON_BG: `${IMG_HOSTING}42007a9252e2c5c271a0cf14c585e211.png`,
    DIALOG_RECHARGE_MASK_BG: `${IMG_HOSTING}8827544904f9110b76110eacd2463280.png`,
    WIDGET_RECHARGE_IMAGE: `${IMG_HOSTING}84c42a6354c93111e89ac5130031caa9.png`,

    DIALOG_SUBSCRIBE_RIGHT_TOP_ICON: `${IMG_HOSTING}ec5b2a83154a1ba42148698b4bdef3a0.png`,

    // 首期优惠订阅折扣角标闪电图标
    PAYWALL_FIRST_TERM_BOLT: `${IMG_HOSTING}bolt.png`,

    // 订阅挽留弹窗
    DISCOUNT_FIRE: `${IMG_HOSTING}aa0af2cd4ec00bfb2a09ed430d3faa50.svg`,
    BENEFIT_AD_FREE_ICON: `${IMG_HOSTING}3eaadfcd666dbf5aa892c158aed4ff0a.svg`,
    BENEFIT_CANCEL_ICON: `${IMG_HOSTING}4727f3679f39d3509886bc70ffae17ba.svg`,
    BENEFIT_UNLIMITED_ICON: `${IMG_HOSTING}0b1fa402f2fb14a4e4925b98b2ad3340.svg`,

    //
};

if (isMainPackage()) {
    IMG_HOSTING_URLS.EMPTY_PLACEHOLDER = `${IMG_HOSTING}empty-placeholder.png`;
} else {
    IMG_HOSTING_URLS.EMPTY_PLACEHOLDER = `${IMG_HOSTING}ae64e36dd48c02965bb51edce13e03ab.png`;
}

/** 付费墙社会证明假头像池（CDN 图，随机取 5 张叠放展示） */
export const PAYWALL_FAKE_AVATARS: string[] = Array.from(
    { length: 10 },
    (_, i) => `${IMG_HOSTING}avatar-${String(i + 1).padStart(2, '0')}.jpg`
);
